import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule } from '@angular/router';

import { ComponentBase } from '../../component.base';

@Component({
  selector: 'app-single-detail',
  templateUrl: './single-detail.component.html',
  styleUrl: './single-detail.component.scss',
  standalone: true,
  imports: [MatIconModule, RouterModule],
})
export class SingleDetailComponent extends ComponentBase {
  private _value: SingleDetailValue;

  @Input() svgIcon: string;
  @Input() label: string;
  @Input() link: string | any[];
  @Input() clickable: boolean;
  @Input() externalLink: string;

  @Output() clickLink = new EventEmitter<boolean>();

  linkClicked(): void {
    this.clickLink.emit(true);
  }

  @Input()
  public get value() {
    return this.memoizedGetValueOrDash(
      this.multiLine
        ? this.convertLineBreaks(this._value, this.keepBlankLines)
        : this._value
    );
  }

  get isValueEmpty(): boolean {
    if (this._value) {
      return false;
    }
    return true;
  }

  public set value(value: SingleDetailValue | Array<SingleDetailValue>) {
    this._value = [].concat(value).join('\n');
  }

  @Input() multiLine: boolean = false;
  @Input() keepBlankLines: boolean = false;

  private convertLineBreaks(
    value: SingleDetailValue,
    keepBlankLines: boolean = false
  ) {
    return String(value).replace(
      keepBlankLines ? /(\r\n|\r|\n)/g : /(\r\n|\r|\n)+/g,
      '<br>'
    );
  }
}

type SingleDetailValue = string | number | null;
